import { useContext, useMemo } from 'react';
// local imports
import { hasLeadership, isManager, isEmployee, isContractor } from '../models/user';
import { type CustomerTicker } from '../config/customer';
import { getTicker } from '../helpers/customer';
import { GlobalContext } from '../context/global';

// Returns the currently valid ticker for the user from the given tickers, if any.
// When on the Job screen, `ticker`/`popup` are cleared unless the ticker is marked with `show_on_job_screen`.
function useTicker(tickers?: CustomerTicker[], atJobScreen = false): CustomerTicker {
  const { user: { data: user } } = useContext(GlobalContext);
  const supv = isManager(user);
  const leader = hasLeadership(user);
  const employee = isEmployee(user);
  const contractor = isContractor(user);

  return useMemo(() => {
    const validTicker = getTicker(supv, leader, employee, contractor, tickers);
    return !atJobScreen || validTicker.show_on_job_screen ? validTicker
      : { ...validTicker, ticker: null, popup: null };
  }, [supv, leader, employee, contractor, tickers, atJobScreen]);
}

export default useTicker;
